var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    "data-name": "Isolation Mode",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.17 8.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #313a4e;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.59,8.04s-.04,0-.06-.01c-1.23-.43-2.32-1.15-3.15-2.1C.62,5.08.15,4.12.03,3.22c-.12-.89.13-1.79.67-2.4.47-.53,1.1-.82,1.84-.82,1.12,0,1.65.58,2.05,1.12.4-.54.93-1.12,2.05-1.12.73,0,1.37.28,1.84.82.54.61.79,1.51.67,2.4-.12.9-.6,1.86-1.35,2.72-.83.94-1.92,1.67-3.15,2.1-.02,0-.04.01-.06.01ZM2.54.39c-.62,0-1.15.24-1.55.68-.46.53-.68,1.31-.58,2.1.2,1.56,1.7,3.59,4.17,4.47,2.47-.89,3.97-2.91,4.17-4.47.1-.78-.11-1.57-.58-2.1-.39-.45-.93-.68-1.55-.68-1.05,0-1.47.58-1.87,1.15l-.02.03c-.04.05-.1.08-.16.08s-.12-.03-.16-.08l-.02-.03c-.4-.56-.82-1.15-1.87-1.15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.55,5.59s-.01,0-.02,0c-.07,0-.14-.06-.16-.13l-.9-2.55-.63,1.49c-.03.07-.1.12-.18.12H1.56c-.11,0-.19-.09-.19-.19s.09-.19.19-.19h1.97l.77-1.84c.03-.07.11-.12.18-.12.08,0,.15.05.18.13l.93,2.65.51-.8c.04-.06.1-.09.16-.09h1.34c.11,0,.19.09.19.19s-.09.19-.19.19h-1.23l-.66,1.04c-.04.06-.1.09-.16.09Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon 1.ae9565206c51cb016190677f1ab4761c.svg";
export { ForwardRef as ReactComponent };